var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAudioOff = function SvgAudioOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.599 16q-1.29 0-1.945-.654Q0 14.7 0 13.428V2.58Q0 1.3.654.654 1.308 0 2.6 0h10.793q1.3 0 1.954.663.654.654.654 1.918v10.847q0 1.273-.654 1.918-.654.654-1.954.654zm.026-1.087h10.75q.733 0 1.131-.39.407-.387.407-1.157V2.643q0-.77-.407-1.158-.398-.398-1.131-.398H2.625q-.75 0-1.149.398-.39.39-.389 1.158v10.723q0 .77.39 1.158.396.39 1.148.389m7.055-2.705q-.275 0-.54-.248L7.01 9.927a.26.26 0 0 0-.16-.053H5.384q-.432 0-.68-.247-.24-.256-.239-.699V7.072q0-.442.239-.69.248-.255.68-.256h1.468q.106 0 .159-.053L9.14 4.03q.293-.274.53-.274.213 0 .337.15a.47.47 0 0 1 .132.336v7.505a.47.47 0 0 1-.123.336.45.45 0 0 1-.336.124"
  })));
};
export default SvgAudioOff;